export default function clientConfig() {
  const config = {
    codCliente: 9178, // HMG 9178 // PRD 2178 // Implantação 8178
    plano: 2, //
    tipo: 2, //
  }

  return config
}
